var render = function render(){var _vm=this,_c=_vm._self._c;return _c('simple-image-preview',{staticStyle:{"width":"600px","height":"600px"},attrs:{"image-url":_vm.imageUrl,"overlay-settings":_vm.overlaySettings,"recipient-name":_vm.recipientQueryString,"hide-handles":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }